import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["badgeProps", "children", "fullWidth", "showBadge", "size", "variant"];
import React, { forwardRef } from 'react';
import MuiButton from '@mui/material/Button';
import { Badge } from '../Badge';
import { useTheme } from '@mui/system';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var badgeProps = props.badgeProps,
    children = props.children,
    fullWidth = props.fullWidth,
    _props$showBadge = props.showBadge,
    showBadge = _props$showBadge === void 0 ? false : _props$showBadge,
    size = props.size,
    variant = props.variant,
    other = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(MuiButton, _extends({
    fullWidth: fullWidth,
    ref: ref,
    size: size,
    sx: {
      whiteSpace: 'nowrap',
      width: fullWidth ? '100%' : 'fit-content'
    },
    variant: variant
  }, other, {
    children: [children, showBadge && /*#__PURE__*/_jsx(Badge, _extends({
      color: "primary",
      size: "sm",
      sx: {
        ml: size === 'xxl' ? theme.spacing(3) : theme.spacing(2)
      },
      type: "pillColor"
    }, badgeProps))]
  }));
});